<template>
    <div data-test-view="reviews-templates-edit-basics">
        <l-reviews-edit-templates-header
            :id="id"
            :title="$t(`reviews.admin.templateBasicsTitle`)"
        />

        <p>{{ $t(`reviews.admin.helpTemplateBasics`) }}</p>
        <hr />

        <l-reviews-edit-basics-template-form :id="id" @next="next" />
    </div>
</template>

<script>
import LReviewsEditTemplatesHeader from "@/components/LReviewsEditTemplatesHeader";
import LReviewsEditBasicsTemplateForm from "@/components/LReviewsEditBasicsTemplateForm";

export default {
    components: {
        LReviewsEditTemplatesHeader,
        LReviewsEditBasicsTemplateForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        next() {
            this.$router.push(`/reviews/templates/edit/${this.id}/scope`);
        },
    },
};
</script>
